<template>
    <div class="homeContentClass">
        <div class="video-container">
            <video class="background-video" autoplay loop muted playsinline>
                <source src="@/assets/videos/1080p.mp4" type="video/mp4">
            </video>
            <!-- <img style="width: 100%;height: 100vh;object-fit: cover;" src="@/assets/portal/1080p2.gif" alt="首页图片"> -->
            <div class="content-overlay">
                <div class="text-content">
                    <h1 class="title not-select">Virtual Design and Construction</h1>
                    <h2 class="subtitle not-select">{{ $t('base.futureProjectTodayPresent') }}</h2>
                    <div class="button-wrapper">
                        <transition name="fade">
                            <a href="https://huabei-2.zos.ctyun.cn/bucket-bicubex/package/BiCubeMotion-3.0.0.zip" target="_blank">
                            <button class="download-btn" >
                                {{$t('base.immediateDownload')}}
                            </button>
                            </a>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
        <!-- 核心亮点 -->
        <div class="core-highlights">
            <div class="highlights-content">
                <div class="main-content">
                    <h2 class="main-title">{{ $t('content.home.title') }}</h2>
                    <div class="features-list">
                        <div class="feature-items">
                            <span class="feature-item">{{ $t('content.home.dataProcessing') }}</span>
                            <span class="divider">|</span>
                            <span class="feature-item">{{ $t('content.home.threeDimensionalVisualization') }}</span>
                            <span class="divider">|</span>
                            <span class="feature-item">{{$t('content.home.zeroCodeThreeDimensionalInteraction')}}</span>
                            <span class="divider">|</span>
                            <span class="feature-item">{{$t('content.home.cloudRenderingVideoStream')}}</span>
                            <span class="divider">|</span>
                            <span class="feature-item">{{$t('content.home.secondaryDevelopmentToolkit')}}</span>
                        </div>
                    </div>
                </div>
                <div class="bottom-title">
                    <div class="title-wrapper">
                        <span class="chinese-title">{{$t('content.home.coreHighlight')}}</span>
                        <span class="sub-title">CORE HIGHLIGHTS</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="feature-showcase data-fusion">
            <div class="showcase-item data-fusion">
                <div class="showcase-content">
                    <h3 class="showcase-title"> {{$t('content.home.multiSourceDataFusion')}}</h3>
                    <p class="showcase-desc">{{$t('content.home.supportdetail')}}</p>
                </div>
                <div class="showcase-image">
                    <img src="@/assets/portal/core-1.png" :alt="$t('content.home.multiSourceDataFusion')">
                </div>
            </div>
        </div>
        <div class="feature-showcase engineering-simulation">
            <div class="showcase-item engineering-simulation">
                <div class="showcase-content">
                    <h3 class="showcase-title"> {{$t('content.home.professionalLevelProject')}}</h3>
                    <p class="showcase-desc">{{$t('content.home.professionaDetail')}}</p>
                </div>
                <div class="showcase-image">
                    <img src="@/assets/portal/core-2.png" :alt="$t('content.home.professionalLevelProject')">
                </div>
            </div>
        </div>
        <div class="feature-showcase data-fusion">
            <div class="showcase-item data-fusion">
                <div class="showcase-content">
                    <h3 class="showcase-title"> {{$t('content.home.zeroCodeDigitalSandbox')}}</h3>
                    <p class="showcase-desc">{{$t('content.home.zeroCodeDigitalSandboxDetail')}}</p>
                </div>
                <div class="showcase-image">
                    <img src="@/assets/portal/core-3.png" :alt="$t('content.home.zeroCodeDigitalSandbox')">
                </div>
            </div>
        </div>
        <div class="feature-showcase engineering-simulation">
            <div class="showcase-item engineering-simulation">
                <div class="showcase-content">
                    <h3 class="showcase-title"> {{$t('content.home.webLightweightRelease')}}</h3>
                    <p class="showcase-desc">{{$t('content.home.webLightweightReleaseDetail')}}</p>
                </div>
                <div class="showcase-image">
                    <img src="@/assets/portal/core-4.png" :alt="$t('content.home.webLightweightRelease')">
                </div>
            </div>
        </div>

        <!-- 核心功能 -->
        <div class="core-functions">
            <div class="functions-content">
                <div class="functions-header">
                    <h2 class="chinese-title">{{$t('content.home.coreFunction')}}</h2>
                    <p class="english-title">CORE FUNCTIONS</p>
                </div>
                <div class="functions-grid">
                    <div class="function-item">
                        <div class="icon-wrapper">
                            <img src="@/assets/portal/procraft.png" alt="BiCube ProCraft">
                        </div>
                        <p class="item-title">BiCube ProCraft</p>
                        <p class="item-desc">{{$t('content.home.dataProcessing')}}</p>
                    </div>
                    <div class="function-item">
                        <div class="icon-wrapper">
                            <img src="@/assets/portal/bimfusion.png" alt="BiCube BIMmtion">
                        </div>
                        <p class="item-title">BiCube BIMmtion</p>
                        <p class="item-desc">{{$t('content.home.threeDimensionalVisualization')}}</p>
                    </div>
                    <div class="function-item">
                        <div class="icon-wrapper">
                            <img src="@/assets/portal/sandtable.png" alt="BiCube Sandtable">
                        </div>
                        <p class="item-title">BiCube Sandtable</p>
                        <p class="item-desc">{{$t('content.home.zeroCodeThreeDimensionalInteraction')}}</p>
                    </div>
                    <div class="function-item">
                        <div class="icon-wrapper">
                            <img src="@/assets/portal/cloud.png" alt="BiCube Cloud">
                        </div>
                        <p class="item-title">BiCube Cloud</p>
                        <p class="item-desc">{{$t('content.home.cloudRenderingVideoStream')}}</p>
                    </div>
                    <div class="function-item">
                        <div class="icon-wrapper">
                            <img src="@/assets/portal/sdk.png" alt="BiCube SDK">
                        </div>
                        <p class="item-title">BiCube SDK</p>
                        <p class="item-desc">{{$t('content.home.secondaryDevelopmentToolkit')}}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 项目应用 -->
        <div class="project-applications">
            <div class="applications-content">
                <div class="applications-header">
                    <h2 class="chinese-title">{{ $t('menu.project') }}</h2>
                    <p class="english-title">PROJECT APPLICATION</p>
                </div>
                <div class="carousel-wrapper">
                    <a-carousel ref="carousel" :after-change="onCarouselChange" :dots="false" :autoplay="true"
                        :autoplaySpeed="2000" :slidesToShow="3" :slidesToScroll="1">
                        <template #default>
                            <div v-for="(item, index) in projectList" :key="`${item.typeId}-${item.projectId}`">
                                <div class="card" @click="handleCardClick" :style="{ margin: '0 16px' }">
                                    <div class="card-image">
                                        <img :src="item.imgURL" :alt="item.title">
                                    </div>
                                    <div class="card-content">
                                        <h3>{{ item.title }}</h3>
                                        <p>{{ item.desc }}</p>
                                    </div>
                                    <span class="more-link not-select"
                                        @click="$router.push({ path: '/projectApplicationDetail', query: { typeId: item.typeId, projectId: item.projectId } })">{{$t('base.learnMore')}}</span>
                                </div>
                            </div>
                        </template>
                    </a-carousel>
                </div>
            </div>
        </div>

        <!-- 下载板块 -->
        <div class="download-section">
            <div class="left-content">
                <img class="logo" src="@/assets/portal/logo.png" alt="BiCube Motion">
                <h2 class="slogan">{{ $t('base.futureProjectTodayPresent') }}</h2>
            </div>
            <div class="right-content">
                <a href="https://huabei-2.zos.ctyun.cn/bucket-bicubex/package/BiCubeMotion-3.0.0.zip">
                <button class="download-button">
                    {{ $t('base.immediateDownload') }}
                </button>
                </a>
            </div>
        </div>

        <!-- 侧边工具栏 -->
        <sidebar-toolbar class="sidebar-toolbar" v-show="showToolbar" />
    </div>
</template>

<script>
import SearchHome from '@/components/SearchHome/index.vue'
import SidebarToolbar from '@/views/productPrice/components/rightInformation.vue'
import { projectApplications,projectApplicationsEn } from "@/config/commonVar"

export default {
    name: 'Home',
    components: {
        SearchHome,
        SidebarToolbar,
    },
    data() {
        return {
            currentSlide: 0,
            showToolbar: false
        }
    },
    computed: {
        projectList() {
            return this.$store.getters.lang === 'en' ? projectApplicationsEn : projectApplications
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        onCarouselChange(current) {
            this.currentSlide = current;
        },
        prevSlide() {
            this.$refs.carousel.prev();
        },
        nextSlide() {
            this.$refs.carousel.next();
        },
        handleCardClick() {
            // 处理卡片点击
        },
        handleScroll() {
            // 获取当前滚动位置
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop
            // 获取视口高度
            const windowHeight = window.innerHeight
            // 当滚动超过一屏时显示工具栏
            this.showToolbar = scrollTop > windowHeight
        }
    }
}
</script>
<style lang="less">
/* 全局隐藏滚动条样式 */
::-webkit-scrollbar {
    display: none;
}
</style>
<style lang="less" scoped>
.homeContentClass {
    width: 100%;
    height: 100%;
}

.video-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;

    .background-video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 1;
    }

    .content-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
        background: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;

        .text-content {
            text-align: center;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .gradient-text {
                background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.8) 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
            }

            .title {
                height: 82px;
                font-family: Roboto, Roboto;
                font-weight: 500;
                font-size: 64px;
                line-height: 75px;
                letter-spacing: 2px;
                text-align: center;
                font-style: normal;
                text-transform: none;
                background: linear-gradient(90deg, #FFFFFF 0%, #FFFFFF 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                margin-bottom: 20px;
                font-weight: bold;
            }

            .subtitle {
                width: 600px;
                height: 78px;
                font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
                font-weight: bold;
                font-size: 64px;
                line-height: 75px;
                letter-spacing: 6px;
                text-align: center;
                font-style: normal;
                text-transform: none;
                background: linear-gradient(180deg, #FFFFFF 32%, rgba(255, 255, 255, 0.1) 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                margin-bottom: 40px;
            }

            .button-wrapper {
                position: absolute;
                bottom: 120px;
                left: 50%;
                transform: translateX(-50%);

                .download-btn {
                    padding: 12px 36px;
                    font-size: 20px;
                    color: #fff;
                    // background-color: transparent;
                    // background-image: url('~@/assets/portal/download.png');
                    // background-size: 100% 100%;
                    // background-repeat: no-repeat;
                    background: linear-gradient(270deg, #d9a8ff 0%, #0166fc 100%);
                    border-radius: 30px;
                    border: none;
                    // border-radius: 4px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    width: 240px;
                    height: 60px;

                    &:hover {
                        transform: translateY(-2px);
                        opacity: 0.9;
                    }
                }
            }
        }
    }
}

.core-highlights {
    width: 100%;
    min-height: 300px;
    background-color: #000;
    padding: 70px 0 42px;
    position: relative;
    z-index: 2;

    .highlights-content {
        max-width: 1200px;
        margin: 0 auto;
        text-align: center;
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 160px;

        .main-content {
            .main-title {
                font-size: 36px;
                color: #FFFFFF;
                font-weight: 500;
                letter-spacing: 1px;
                margin-bottom: 30px;
            }
        }

        .bottom-title {
            margin-top: 70px;
            text-align: center;

            .title-wrapper {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 8px;
            }

            .chinese-title {
                font-size: 36px;
                color: #FFFFFF;
                // font-weight: bold;
                letter-spacing: 2px;
            }

            .sub-title {
                font-size: 14px;
                color: rgba(255, 255, 255, 0.6);
                text-transform: uppercase;
                letter-spacing: 2px;
            }
        }

        .features-list {
            .feature-items {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 20px;

                .feature-item {
                    color: rgba(255, 255, 255, 0.8);
                    font-size: 20px;
                    white-space: nowrap;
                    transition: color 0.3s ease;
                    cursor: pointer;

                    &:hover {
                        color: #FFFFFF;
                    }
                }

                .divider {
                    color: rgba(255, 255, 255, 0.4);
                    font-weight: 200;
                }
            }
        }
    }
}

.sidebar-toolbar {
    z-index: 3
}

.feature-showcase {
    background-color: #000;
    position: relative;
    transition: all 0.3s ease;
    overflow: hidden;

    &.data-fusion {
        background-color: #1A1A1A;

        &::before {
            background: linear-gradient(90deg,
                    rgba(217, 168, 255, 0.02) 0%,
                    rgba(1, 102, 252, 0.02) 100%);
        }
    }

    &.engineering-simulation {

        // background-color: #111425;
        &::before {
            background: linear-gradient(270deg,
                    rgba(217, 168, 255, 0.02) 0%,
                    rgba(1, 102, 252, 0.02) 100%);
        }
    }

    &:hover {
        &::before {
            opacity: 1;
            filter: blur(20px);
        }

        &::after {
            opacity: 0.15;
        }
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -10%;
        width: 120%;
        height: 100%;
        opacity: 0;
        transition: all 0.6s ease;
        pointer-events: none;
    }

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to bottom,
                rgba(217, 168, 255, 0) 0%,
                rgba(1, 102, 252, 0.05) 50%,
                rgba(217, 168, 255, 0) 100%);
        opacity: 0;
        transition: opacity 0.6s ease;
        pointer-events: none;
    }

    .showcase-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 1300px;
        margin: 0 auto;
        padding: 80px 0;
        position: relative;
        z-index: 1;

        &.engineering-simulation {
            flex-direction: row-reverse;
            // justify-content: flex-end;
        }

        .showcase-content {
            flex: 1;
            padding: 0;
            max-width: 480px;

            .showcase-title {
                font-size: 28px;
                color: #FFFFFF;
                margin-bottom: 24px;
                font-weight: 500;
            }

            .showcase-desc {
                font-size: 16px;
                color: rgba(255, 255, 255, 0.6);
                line-height: 30px;
                max-width: 480px;
            }
        }

        .showcase-image {
            width: 743px;
            height: 418px;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            transition: transform 0.3s ease;
            cursor: pointer;

            &:hover {
                transform: translateY(-8px);
                box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);

                img {
                    filter: brightness(1.1);
                }

                &::before {
                    background: linear-gradient(270deg,
                            rgba(217, 168, 255, 1),
                            rgba(1, 102, 252, 1)) border-box;
                    box-shadow: 0 0 20px rgba(217, 168, 255, 0.3),
                        inset 0 0 20px rgba(1, 102, 252, 0.3);
                }

                &::after {
                    opacity: 1;
                }
            }

            &::after {
                content: '';
                position: absolute;
                top: -10px;
                left: -10px;
                right: -10px;
                bottom: -10px;
                background: radial-gradient(circle at center,
                        rgba(217, 168, 255, 0.1) 0%,
                        rgba(1, 102, 252, 0.1) 100%);
                filter: blur(15px);
                opacity: 0;
                transition: opacity 0.3s ease;
                pointer-events: none;
                z-index: 0;
            }

            img {
                max-width: 100%;
                height: auto;
                border-radius: 16px;
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: filter 0.3s ease;
                z-index: 1;
            }

            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                border: 2px solid transparent;
                border-radius: 16px;
                background: linear-gradient(270deg,
                        rgba(217, 168, 255, 0.8),
                        rgba(1, 102, 252, 0.8)) border-box;
                -webkit-mask:
                    linear-gradient(#fff 0 0) padding-box,
                    linear-gradient(#fff 0 0);
                -webkit-mask-composite: destination-out;
                mask-composite: exclude;
                pointer-events: none;
                transition: background 0.3s ease;
                z-index: 2;
                box-shadow: 0 0 10px rgba(217, 168, 255, 0.1),
                    inset 0 0 10px rgba(1, 102, 252, 0.1);
            }
        }
    }
}

.core-functions {
    background-color: #000;
    padding-bottom: 80px;

    .functions-content {
        max-width: 1300px;
        margin: 0 auto;

        .functions-header {
            text-align: center;
            margin-bottom: 60px;

            .chinese-title {
                font-size: 36px;
                color: #FFFFFF;
                margin-bottom: 8px;
                font-weight: 500;
            }

            .english-title {
                font-size: 14px;
                color: rgba(255, 255, 255, 0.6);
                text-transform: uppercase;
                letter-spacing: 2px;
            }
        }

        .functions-grid {
            display: flex;
            justify-content: space-between;
            gap: 24px;

            .function-item {
                text-align: center;
                padding: 32px 32px;
                transition: all 0.3s ease;
                cursor: pointer;
                // background: #1C2124;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(49, 145, 255, 0.1) 100%), #151B1D;
                border-radius: 8px;
                width: 247px;

                &:hover {
                    transform: translateY(-5px);

                    .icon-wrapper {
                        img {
                            transform: scale(1.1);
                        }
                    }
                }

                .icon-wrapper {
                    width: 160px;
                    height: 160px;
                    margin: 0 auto;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                        transition: transform 0.3s ease;
                    }
                }

                .item-title {
                    font-size: 18px;
                    color: #FFFFFF;
                    margin-bottom: 12px;
                    font-weight: 500;
                }

                .item-desc {
                    font-size: 14px;
                    color: #86909C;
                    line-height: 20px;
                }
            }
        }
    }
}

.project-applications {
    background-color: #000;
    padding-bottom: 80px;

    .applications-content {
        max-width: 1316px;
        margin: 0 auto;

        .applications-header {
            text-align: center;
            margin-bottom: 60px;

            .chinese-title {
                font-size: 36px;
                color: #FFFFFF;
                margin-bottom: 8px;
                font-weight: 500;
            }

            .english-title {
                font-size: 14px;
                color: rgba(255, 255, 255, 0.6);
                text-transform: uppercase;
                letter-spacing: 2px;
            }
        }

        .carousel-wrapper {
            position: relative;
            overflow: hidden;

            .card {
                flex: 1;
                // background: red;
                // background: linear-gradient(180deg, rgba(28, 106, 184, 0) 0%, rgba(69, 128, 255, 0.2) 100%), #0C0C0C;
                border-radius: 8px;
                overflow: hidden;
                cursor: pointer;
                transition: all 0.3s ease;
                position: relative;
                border: 2px solid #333;
                height: 452px;

                &:hover {
                    .card-image {
                        top: -240px;
                    }

                    .card-content {
                        top: 0;
                        height: 100%;

                        >p {
                            -webkit-line-clamp: unset;
                            overflow: auto;
                        }
                    }
                }

                .card-image {
                    height: 240px;
                    overflow: hidden;
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    z-index: 2;
                    transition: top 0.5s ease;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    &::after {
                        content: '';
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        height: 60%;
                        // background: linear-gradient(to bottom,
                        //         rgba(0, 0, 0, 0) 0%,
                        //         rgba(0, 0, 0, 0.8) 100%);
                        pointer-events: none;
                    }
                }

                .card-content {
                    padding: 32px 32px 60px;
                    position: absolute;
                    top: 240px;
                    left: 0;
                    right: 0;
                    height: 212px;
                    z-index: 1;
                    // background: #1A1A1A;
                    background: linear-gradient(180deg, rgba(28, 106, 184, 0) 0%, rgba(69, 128, 255, 0.2) 100%), #0C0C0C;

                    transition: all 0.5s ease;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;

                    h3 {
                        font-size: 20px;
                        color: #FFFFFF;
                        margin-bottom: 12px;
                        font-weight: 500;
                    }

                    p {
                        font-size: 14px;
                        color: rgba(255, 255, 255, 0.6);
                        line-height: 30px;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        &:hover {
                            // -webkit-line-clamp: unset;
                        }
                    }

                    .more-link {
                        position: absolute;
                        bottom: 32px;
                        left: 32px;
                        color: #FFFFFF;
                        font-size: 14px;
                        transition: all 0.3s ease;
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        z-index: 3;

                        &::after {
                            content: '';
                            width: 16px;
                            height: 16px;
                            background: url('~@/assets/portal/arrow-right.png') no-repeat center;
                            background-size: contain;
                            transition: transform 0.3s ease;
                        }
                    }
                }

                .more-link {
                    position: absolute;
                    bottom: 32px;
                    left: 32px;
                    color: #FFFFFF;
                    font-size: 14px;
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    z-index: 3;

                    &::after {
                        content: '';
                        width: 16px;
                        height: 16px;
                        background: url('~@/assets/portal/arrow-right.png') no-repeat center;
                        background-size: contain;
                        transition: transform 0.3s ease;
                    }
                }
            }

            .carousel-controls {
                .control-btn {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 40px;
                    height: 40px;
                    background: rgba(255, 255, 255, 0.1);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.3s ease;

                    &:hover {
                        background: rgba(255, 255, 255, 0.2);
                    }

                    &.prev {
                        left: -60px;
                    }

                    &.next {
                        right: -60px;
                    }
                }
            }
        }
    }
}

.download-section {
    background: url('~@/assets/portal/sub_bg.png') no-repeat;
    background-size: cover;
    height: 360px;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
    }

    .left-content {
        position: absolute;
        right: 300px;
        top: 66px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        z-index: 2;

        .logo {
            width: 334px;
            height: auto;
            user-select: none;
            pointer-events: none;
            -webkit-user-drag: none;
        }

        .slogan {
            width: 100%;
            font-size: 24px;
            color: rgba(255, 255, 255, 0.6);
            font-weight: 500;
            margin: 0;
            letter-spacing: 1px;
            opacity: 0.8;
            text-align: center;
            user-select: none;
        }
    }

    .right-content {
        position: absolute;
        right: 340px;
        bottom: 72px;
        z-index: 2;

        .download-button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 240px;
            height: 60px;
            border: none;
            cursor: pointer;
            transition: all 0.3s ease;
            font-size: 20px;
            font-weight: 500;
            // background-image: url(~@/assets/portal/download.png);
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            border-radius: 30px;
            background-color: #3F4144;
            color: #fff;
            // cursor: not-allowed;
            &:hover {
                transform: translateY(-2px);
                opacity: 0.9;
            }
        }
    }
}

:deep(.ant-carousel) {
    .slick-slide {
        pointer-events: auto;
    }

    .slick-track {
        display: flex !important;
    }

    .slick-list {
        margin: 0 -10px;
    }

    .slick-slide>div {
        height: 100%;
    }
}
</style>
